'use client';

import type { TagProps } from './types';

export default function Tag({ children, className }: TagProps) {
    return <span className={className}>{children}</span>;
}
